<!--
 * @Author: 李明明
 * @Date: 2024-02-29 10:45:49
 * @LastEditTime: 2024-03-01 10:12:12
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /pc用户端/jctt-pc/src/views/user/components/addInvoice.vue
 * 代码版权方：'政府采购信息网'
-->
<!-- 新增发票抬头 -->
<template>
  <div class=''>
    <el-dialog title="新增发票抬头" :visible.sync="addInvoiceVisible" width="500px" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" center>
      <el-form :model="addInvoiceForm" ref="addInvoiceRef" :rules="addInvoiceRules" label-width="110px" :inline="false">
        <el-form-item label="抬头类型" prop="type">
          <el-radio-group v-model="addInvoiceForm.type" @change="ChangeResource">
            <el-radio :label="1">个人</el-radio>
            <el-radio :label="2">企业</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票类型" prop="invoice_type">
          <p style="font-size: 14px;">增值税普通发票</p>

        </el-form-item>
        <el-form-item label="发票抬头" prop="header">
          <el-input v-model="addInvoiceForm.header" placeholder="请输入发票抬头" clearable @change=""></el-input>

        </el-form-item>
        <el-form-item label="纳税人识别码" prop="taxpayer">
          <el-input v-model="addInvoiceForm.taxpayer" placeholder="请输入纳税人识别码" clearable @change=""></el-input>
        </el-form-item>
        <el-form-item label="开户行" v-if="addInvoiceForm.type == 2" prop="bank_account">
          <el-input v-model="addInvoiceForm.bank_account" placeholder="请输入开户行信息" clearable @change=""></el-input>
        </el-form-item>
        <el-form-item label="银行账户" v-if="addInvoiceForm.type == 2" prop="bank_num">
          <el-input v-model="addInvoiceForm.bank_num" placeholder="请输入银行账户信息" clearable @change=""></el-input>
        </el-form-item>
        <el-form-item label="注册地址" v-if="addInvoiceForm.type == 2" prop="register_address">
          <el-input v-model="addInvoiceForm.register_address" placeholder="请输入注册地址" clearable @change=""></el-input>
        </el-form-item>
        <el-form-item label="注册电话" v-if="addInvoiceForm.type == 2" prop="register_tel">
          <el-input v-model="addInvoiceForm.register_tel" placeholder="请输入注册电话" clearable @change=""></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="addInvoiceForm.email" placeholder="请输入邮箱" clearable @change=""></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer">
        <el-button @click="CloseAddInvoice">取消</el-button>
        <el-button type="primary" @click="SaveInvoice('addInvoiceRef')">保存</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
let dutyRules = (rule, value, callback) => {
  let dutyReg = /^[a-zA-Z0-9]{15}$|^[a-zA-Z0-9]{18}$/;
  console.log(value);
  if (!value) {
    callback();
  } else {
    if (!dutyReg.test(value)) {
      callback(new Error("税号需要为15位或者18位数字或字母"));
    } else {
      callback();
    }
  }
};

// 邮箱
let emailRules = (rule, value, callback) => {
  let emailReg =
    /^([a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-z]{2,})$/;
  if (!emailReg.test(value)) {
    callback(new Error("请输入正确的邮箱"));
  } else {
    callback();
  }
};
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: ['addInvoiceVisible', 'invoiceType'],
  data () {
    // 这里存放数据
    return {
      addInvoiceForm: {
        type: 1, //抬头类型
        invoice_type: 1, //发票类型
        taxpayer: "", //纳税人
        header: "", //发票抬头
        bank_account: "", //开户行
        bank_num: "", //银行账户
        register_address: "", //注册地址
        register_tel: "", //电话
        checked: "",
        email: "",  //邮箱
      },
      addInvoiceRef: null,
      addInvoiceRules: {
        type: [
          { required: true, message: '请选择抬头类型', trigger: 'blur' },

        ],
        invoice_type: [
          { required: true, message: '请选择发票类型', trigger: 'blur' },

        ],
        header: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' },

        ],
        taxpayer: [
          { required: true, message: '请输入纳税人识别码', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: emailRules, trigger: 'blur' }
        ]
      }
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    addInvoiceVisible: {
      handler (val) {
        if (val) {
          console.log(this.invoiceType);
          this.addInvoiceForm.type = Number(this.invoiceType)
          console.log(this.addInvoiceForm);
        }
      }
    },
    addInvoiceForm: {
      handler (val) {
        if (val.type == 1) {
          this.addInvoiceRules.taxpayer = [
            {
              validator: dutyRules,
              trigger: "blur",
            },
          ]
        } else {
          this.addInvoiceRules.taxpayer = [
            { required: true, message: '请输入纳税人识别码', trigger: 'blur' },
            {
              validator: dutyRules,
              trigger: "blur",
            },
          ]
        }
      },
      deep: true
    }
  },
  // 方法集合
  methods: {
    /**
     * @description: 修改发票抬头类型
     * @return {*}
     */
    ChangeResource (val) {
      this.$refs['addInvoiceRef'].clearValidate()
      // 个人
      if (val == 1) {
        this.addInvoiceRules.taxpayer = [
          {
            validator: dutyRules,
            trigger: "blur",
          },
        ]
      } else {
        this.addInvoiceRules.taxpayer = [
          { required: true, message: '请输入纳税人识别码', trigger: 'blur' },
          {
            validator: dutyRules,
            trigger: "blur",
          },
        ]
      }
    },
    /**
     * @description: 保存发票信息
     * @param {
     *  formName: 发票表单元素
     * }
     * @return {*}
     */
    SaveInvoice (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api
            .addinvoice(this.addInvoiceForm)
            .then(res => {
              console.log(res);
              this.$refs['addInvoiceRef'].resetFields()
              this.$emit('SaveInvoice')
            }).catch(e => {
              console.log(e);
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * @description: 关闭新增发票抬头弹窗
     * @return {*}
     */
    CloseAddInvoice () {

      this.$refs['addInvoiceRef'].resetFields()
      this.$emit('CloseAddInvoice')
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
</style>